import { render, staticRenderFns } from "./PersistNotasInseridasConfiguracaoView.vue?vue&type=template&id=63e1ce81&"
import script from "./PersistNotasInseridasConfiguracaoView.vue?vue&type=script&lang=ts&"
export * from "./PersistNotasInseridasConfiguracaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports